<form class="flex grow flex-col gap-4" [formGroup]="formGroup">
  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Comparison</mat-label>
    <mat-select formControlName="comparison" required>
      @for (comparison of comparisons; track comparison) {
        <mat-option [value]="comparison.value">
          {{ comparison.label }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (formGroup.state$ | async; as state) {
    @if (state.showDateTypeField) {
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Date Range</mat-label>
        <mat-select formControlName="dateType" required>
          @for (dateType of state.dateTypes; track dateType.value) {
            <mat-option [value]="dateType.value">
              {{ dateType.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (state.showSpecificDateSection) {
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Choose a date</mat-label>
        <input matInput formControlName="date" [matDatepicker]="picker" />
        <mat-datepicker-toggle matIconSuffix [for]="picker" />
        <mat-datepicker #picker />
      </mat-form-field>

      <div class="text-xs opacity-50">
        This report will be always be run against this date. You will not be
        able to select a date when running the report. Used for reports on a set
        date.
      </div>
    }

    @if (state.showSpecificDateRangeSection) {
      <pt-date-range-form
        [from]="formGroup.value.dateFrom"
        [to]="formGroup.value.dateTo"
        [useRangePicker]="true"
        (fromChange)="dateFromChange($event)"
        (toChange)="dateToChange($event)"
      />

      <div class="text-xs opacity-50">
        This report will be always be run against this date range. You will not
        be able to select a date range when running the report. Used for reports
        on a set date range, like financial year or performance reviews.
      </div>
    }

    @if (state.showReportDateSection) {
      <div class="text-xs opacity-50">
        This report allows you to select a date when running the report.
        Defaults to 'Today'
      </div>
    }

    @if (state.showDynamicDateSection) {
      <div class="flex flex-row flex-wrap gap-4">
        <mat-form-field class="w-32" subscriptSizing="dynamic">
          <mat-label>Amount</mat-label>
          <input
            matInput
            formControlName="amount"
            type="number"
            min="1"
            required
          />
        </mat-form-field>

        <mat-form-field class="w-32" subscriptSizing="dynamic">
          <mat-label>Unit</mat-label>
          <mat-select formControlName="unit" required>
            @for (unit of timingUnits; track unit) {
              <mat-option [value]="unit"> {{ unit }} </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field class="flex grow" subscriptSizing="dynamic">
          <mat-label>Direction</mat-label>
          <mat-select formControlName="direction" required>
            @for (direction of timingDirections; track direction) {
              <mat-option [value]="direction">
                {{ direction }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="text-xs opacity-50">
        This report will use a date relative to the date selected when running
        the report.
      </div>
    }
  }
</form>
